/**
 * Le registre de l'espace tuteur : la fusion des `routes.ts` de chaque lot — les routes poussées que
 * `tutorSpaceBridge` lit, et les onglets que la coquille (`TutorNavigator`) lit.
 *
 * Un lot n'écrit que dans son propre `routes.ts`, qui ne peut inscrire que ses routes et ses onglets :
 * les lots travaillent en parallèle sans se marcher dessus, et ce fichier ne bouge plus après le socle.
 */
import { accountRoutes, accountTabs } from "./Account/routes"
import { applicationRoutes, applicationTabs } from "./Application/routes"
import { availabilityRoutes, availabilityTabs } from "./Availability/routes"
import { homeTabs } from "./Home/routes"
import { livesRoutes } from "./Lives/routes"
import { preCallRoutes } from "./PreCall/routes"
import { roomRouteGuards, roomRoutes } from "./Room/routes"
import { studentsRouteParamGuards, studentsRoutes, studentsTabs } from "./Students/routes"
import {
    type TutorCandidateRouteTable,
    type TutorCandidateTabTable,
    type TutorSpaceRouteEntry,
    type TutorSpaceRouteName,
    type TutorSpaceScreen,
    type TutorSpaceTabName,
} from "./tutorSpaceRouteTypes"

export const tutorSpaceRoutes: Partial<Record<TutorSpaceRouteName, TutorSpaceRouteEntry>> = {
    ...availabilityRoutes,
    ...livesRoutes,
    ...roomRoutes,
    ...preCallRoutes,
    ...accountRoutes,
    ...studentsRoutes,
}

/**
 * Les gardes d'une route inscrite sur l'état du store, lues une fois par écran monté : elles la rendent au
 * legacy quand elles disent non (la salle sans `events-panel`), et une salle ne change pas d'arbre en pleine
 * séance.
 */
export const tutorSpaceRouteGuards: Partial<Record<TutorSpaceRouteName, (state: unknown) => boolean>> = {
    ...roomRouteGuards,
}

/**
 * Les gardes d'une route inscrite sur ses paramètres, relues à chaque rendu : les paramètres disent qui
 * l'ouvre (`student` poussée par la relecture anonyme des activités), et une route réutilisée par
 * `navigate` ou `setParams` avec d'autres paramètres relit sa garde.
 */
export const tutorSpaceRouteParamGuards: Partial<Record<TutorSpaceRouteName, (params: unknown) => boolean>> = {
    ...studentsRouteParamGuards,
}

export const tutorSpaceTabs: Partial<Record<TutorSpaceTabName, TutorSpaceScreen>> = {
    ...homeTabs,
    ...availabilityTabs,
    ...accountTabs,
    ...studentsTabs,
}

/**
 * Le registre du candidat : sa candidature seule (routes poussées et onglet d'accueil). Un candidat
 * ne lit que lui, un tuteur jamais.
 */
export const tutorCandidateRoutes: TutorCandidateRouteTable = applicationRoutes
export const tutorCandidateTabs: TutorCandidateTabTable = applicationTabs
